<template>
    <v-container grid-list-xl fluid>
        <v-layout wrap>
            <v-flex xs12>
                <h1>Coleta em CD</h1>
                <v-divider class=" mb-2" />
            </v-flex>
        </v-layout>

        <v-layout wrap v-if="step >= 1">
            <v-flex xs12>
                <div class="subtitle-1" v-if="item.code"><strong>Embarque:</strong> {{ item.code }}</div>
                <div class="subtitle-1" v-if="item.store"><strong>Loja:</strong> {{ item.store.name }}</div>
            </v-flex>
        </v-layout>

        <v-layout wrap v-if="step == null">
            <ChecklistHistory type="collect-cd" @reopen="reopen" />
            <StoreList labelNotFound="Não foi localizado nenhum CD de destino." labelSelect="Seleciona abaixo o CD de destino:" endpoint="checklists/collect-cd/stores"
                @selected="start" />
        </v-layout>

        <v-layout wrap v-else-if="step == 1">
            <v-flex xs12>
                <v-form ref="formStep2" @submit.prevent="">
                    <v-text-field :label="$t('Digite o número de pedidos')" v-model="item.ordersNumber" :rules="[rules.required, rules.range(1, 1000)]" type=" number" clearable
                        v-on:keyup.enter="startBip" ref="ordersNumberField" />
                </v-form>
            </v-flex>
            <v-flex xs12>
                <v-btn color="success" :disabled="item.ordersNumber == null" @click="startBip" class="mx-auto" width="100%">
                    Iniciar Bipagem
                </v-btn>
            </v-flex>
        </v-layout>

        <v-layout wrap v-else-if="step == 2">
            <v-flex xs12 sm6 md6 class="pa-0 pb-4">
                <v-card :color="reachedGoal ? 'success' : 'grey'">
                    <v-card-text class="white--text">
                        <div class="headline mb-2">
                            <v-icon dark>luggage</v-icon>
                            {{ item.ordersNumber }}
                        </div>
                        Número de pedidos informado
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 class="pa-0" v-if="item">
                <v-card :color="reachedGoal ? 'success' : 'primary'">
                    <v-card-text class="white--text">
                        <div class="headline mb-2">
                            <v-icon dark>receipt</v-icon>
                            {{ item.count }}
                        </div>
                        Número de pedidos bipados
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-btn @click="showQRCode = true" color="success" class="mt-12" width="100%"> <v-icon left>qr_code_scanner</v-icon>Bipar Pedido </v-btn>
            </v-flex>
            <v-flex xs12 mt-12>
                <v-btn color="error" @click="finishStep1" class="mx-auto" width="100%">Encerrar bipagem</v-btn>
            </v-flex>
        </v-layout>

        <v-layout wrap v-else-if="step == 3">
            <v-flex xs12>
                <v-btn color="success" @click="finishStep2" class="mx-auto" width="100%" :disabled="!item.extraCode">Finalizar</v-btn>
            </v-flex>
            <v-flex xs12>
                <v-text-field :label="$t('Digite o número do embarque (Romaneio)')" :rules="[rules.required]" v-model="item.extraCode" v-on:keyup.enter="createChecklist" clearable
                    ref="codeField" />
            </v-flex>
            <v-flex xs12>
                <h1>Lacre</h1>
                <v-divider class=" mb-2" />
            </v-flex>
            <v-flex xs12>
                <v-text-field :label="$t('Inserir código de lacre')" v-model="stamp" append-outer-icon="mdi-send" v-on:keyup.enter="addStamp" @click:append-outer="addStamp"
                    clearable />
            </v-flex>
            <v-flex xs12 class="mb-12">
                <v-list v-for="(stamp, index) in item.stamps" :key="index" width="100vw">
                    <v-list-item>
                        <v-list-item-title>Lacre: {{ stamp }}</v-list-item-title>
                        <v-list-item-icon>
                            <v-icon color="red" @click="item.stamps.splice(index, 1)">delete</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                    <v-divider :key="index" />
                </v-list>
            </v-flex>
        </v-layout>

        <BarCode :show="showQRCode" @close="showQRCode = false" @onRead="readedQRCode">
            <template slot="header">
                <v-switch v-model="makeNoteBig" inset :label="$t('Marcar item como volumoso')" dense class="mt-n1" />
                <v-alert dense class="white--text" color="black" prominent border="left" v-if="information && (information.success || information.warning || information.error)">
                    <h2 class="white--text text-subtitle-1 text-left"><strong>Última leitura:</strong></h2>
                    <h2 class="green--text my-2" v-if="information.success" v-html="information.success"></h2>
                    <h2 class="orange--text my-2" v-if="information.warning" v-html="information.warning"></h2>
                    <h2 class="red--text my-2" v-if="information.error" v-html="information.error"></h2>
                </v-alert>
            </template>
        </BarCode>
        <ConfirmModal confirmText="Confirmar" cancelText="Cancelar" ref="confirm" />

        <MessageDialog :options="messageDialogOption" @close="closeBeepFeedback">
            <template slot="afterMessage">
                <div class="white--text" v-if="codeBippedToCheck">{{ $t("Código lido:") }} {{ codeBippedToCheck }}</div>
            </template>
        </MessageDialog>

    </v-container>
</template>

<script>
import rules from "@/helpers/rules";

import MessageDialog from "@/components/core/MessageDialog";
import ConfirmModal from "@/components/core/ConfirmModal";
import BarCode from "@/components/core/BarCode";
import StoreList from "@/components/shared/StoreList";
import ChecklistHistory from "@/components/shared/ChecklistHistory";

const itemClean = {
    extraCode: null,
    ordersNumber: null,
    store: null,
    stamps: [],
};

export default {
    components: { MessageDialog, ConfirmModal, BarCode, StoreList, ChecklistHistory },

    data() {
        return {
            rules,
            loaded: false,
            showQRCode: false,
            makeNoteBig: false,
            messageDialogOption: undefined,
            information: { success: null, warning: null, error: null },
            codeBippedToCheck: null,
            step: null,
            item: JSON.parse(JSON.stringify(itemClean)),
            finishResult: null,
            stamp: null,
        };
    },

    computed: {
        reachedGoal() {
            return this.item && this.item.count >= this.item.ordersNumber;
        },
        inGoal() {
            return this.item && this.item.count == this.item.ordersNumber;
        },
        packagesBipped() {
            return this.item.ordersChecked ? this.item.ordersChecked.length : 0;
        },
        ordersBipped() {
            let a = this.item.ordersChecked;
            let uniqueArray = a.filter(function (item, pos) {
                return a.indexOf(item) == pos;
            });
            return uniqueArray.length;
        },
    },

    methods: {
        reopen(result) {
            if (result) {
                this.item = result;
                this.step = 2;
            }
        },
        addStamp() {
            if (this.stamp) {
                if (this.item.stamps == undefined) {
                    this.item.stamps = []
                }
                this.item.stamps.push(this.stamp);
                this.stamp = null;
            } else {
                this.$eventHub.$emit("msgError", this.$t("Digite um valor valido de lacre."));
            }
        },
        readedQRCode(QRCode) {
            this.codeBippedToCheck = QRCode;
            this.bip();
        },
        start(store) {
            this.finishResult = null;
            this.item = JSON.parse(JSON.stringify(itemClean));
            this.item.store = store;
            this.step = 1;
            this.$nextTick(() => this.$refs.ordersNumberField.focus());
        },
        startBip() {
            if (this.$refs.formStep2.validate())
                this.$http
                    .post(`checklists/collect-cd/create`, this.item)
                    .then((result) => {
                        if (result) {
                            this.item = result;
                            this.step = 2;
                        } else {
                            this.$eventHub.$emit("msgError", this.$t("Erro ao criar um romaneio. (1)"));
                        }
                    })
                    .catch((error) => {
                        this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao criar um romaneio. (2)"));
                    });
        },
        closeBeepFeedback() {
            if (this.inGoal) {
                this.$eventHub.$emit("msgSuccess", this.$t("Já foram bipados o número de pacotes informado."));
            }
            this.showQRCode = true;
        },
        async bip() {
            this.showQRCode = false;
            this.information = { success: null, warning: null, error: null };
            this.messageDialogOption = { msg: "Conferindo...", type: "info" };

            if (this.codeBippedToCheck == null) {
                this.messageDialogOption = { msg: "Código inválido.", type: "critical" };
            } else {
                await this.$http
                    .patch(`checklists/collect-cd/bip/${this.item.code}`, { data: { store: this.item.store.id, ticket: this.codeBippedToCheck, makeNoteBig: this.makeNoteBig } })
                    .then((result) => {
                        if (result) {
                            this.information.success = `<strong>Código:</strong> ${this.codeBippedToCheck}`;
                            if (result.created) {
                                this.information.warning = `Pacote criado.`;
                            }
                            if (result.region) {
                                if (result.region.store && result.region.store.id != this.item.store.id) {
                                    this.information.error = `ALERTA: pacote deveria estar indo para: '${result.region.store.name}'<br><br>Região: ${result.region.name}`;
                                } else {
                                    this.information.error = `Região: <strong>${result.region.name}</strong>`;
                                }
                            }
                            this.messageDialogOption = { msg: "Pedido localizado com sucesso.", type: "success" };
                            if (result.checklist) {
                                this.item = result.checklist;
                            }
                        } else {
                            this.messageDialogOption = { msg: "Pedido não localizado", type: "critical" };
                        }
                    })
                    .catch((error) => {
                        this.messageDialogOption = { msg: error.message ? error.message : this.$t("Erro ao localizar pedido"), type: "critical" };
                    });
            }
        },
        restartScreen() {
            this.loaded = false;
            this.showQRCode = false;
            this.codeBippedToCheck = null;
            this.step = null;
            this.item = JSON.parse(JSON.stringify(itemClean));
            this.finishResult = null;
        },
        updateOrder() {
            this.$http
                .patch(`checklists/collect-cd/update/${this.item.code}`, { data: { extraCode: this.item.extraCode, stamps: this.item.stamps } })
                .then((result) => {
                    if (result) {
                        this.restartScreen();
                    } else {
                        this.$eventHub.$emit("msgError", this.$t("Erro ao atualizar dados do romaneio."));
                    }
                })
                .catch((error) => {
                    this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao atualizar dados do romaneio."));

                });
        },
        finishStep1() {
            this.$refs.confirm.open("", "Deseja mesmo encerrar o embarque?").then((confirm) => {
                if (confirm) {
                    this.$http
                        .patch(`checklists/collect-cd/finish/${this.item.code}`)
                        .then(() => {
                            this.step = 3;
                            this.$nextTick(() => this.$refs.codeField.focus());
                        })
                        .catch((error) => {
                            this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao atualizar dados do romaneio."));
                        });
                }
            });
        },
        finishStep2() {
            if (this.item.extraCode) {
                if (this.item.stamps && this.item.stamps.length > 0) {
                    this.updateOrder();
                } else {
                    this.$refs.confirm.open("", "Deseja continuar sem digitar código de lacre?").then((confirm) => {
                        if (confirm) {
                            this.updateOrder();
                        }
                    });
                }

            } else {
                this.$eventHub.$emit("msgError", this.$t("Preencha o código de romaneio."));
            }
        },
    },
};
</script>